import React from 'react'
import { Row } from 'antd'
import { options } from './options'
import { useTranslation } from 'next-i18next'
import { useWindowSize } from 'src/app/hooks'
import styles from './MyProjectListHeader.module.scss'
import { CustomTitle, CustomCol } from 'src/components'

const MyProjectListHeader: React.FC<{ projectsLength: number }> = (props) => {
  const { t } = useTranslation()
  const { width } = useWindowSize()
  const isMobileView = width <= 800

  return (
    <Row>
      <CustomCol lg={9}>
        <CustomTitle
          className={isMobileView && styles.textMovile}
          label={t('general.ResultsLength', { length: props.projectsLength })}
        />
      </CustomCol>
      <CustomCol lg={5}>
        <options.ProjectFilterVintages />
      </CustomCol>
      <CustomCol lg={5} className={!isMobileView && 'pr-3'}>
        <options.ProjectFilterInput />
      </CustomCol>
      <CustomCol lg={5} xs={24} className='has-text-centered'>
        <options.ProjectCreateButton />
      </CustomCol>
    </Row>
  )
}

export default MyProjectListHeader
